// extracted by mini-css-extract-plugin
export var content = "layout-module--content--2OoP5";
export var footer = "layout-module--footer--1gnK_";
export var footerWrapper = "layout-module--footerWrapper--3LXWw";
export var companyAddress = "layout-module--companyAddress--3AOsh";
export var siteInfo = "layout-module--siteInfo--Rt31u";